import styled from 'styled-components'

export const CopyButton = styled.button`
  width: 5rem;
  height: 5rem;
  border-radius: 0.5rem;
  background-color: #3a64f8;
  border: none;

  &:hover {
    background-color: #6b8bfa;
  }
`
